import React, { useEffect } from "react";
import * as S from '../scss/theme';
import './MainPage.scss';
import MainPageSub01 from './MainPageSub01';
import MainPageSub02 from './MainPageSub02';
import MainPageSub03 from './MainPageSub03_1';
import MainPageSub04_0 from './MainPageSub04_0';
import MainPageSub04_1 from './MainPageSub04_1';
import MainPageSub04_2 from './MainPageSub04_2';
import MainPageSub04_3 from './MainPageSub04_3';
import MainPageSub05_0 from './MainPageSub05_0';
import MainPageSub06_1 from './MainPageSub06_1';
import MainPageSub07_1 from './MainPageSub07_1';

import Footer from '../Footer';

import 'aos/dist/aos.css';
import AOS from 'aos';

const MainPage = () => {
    useEffect(() => {
        AOS.init({
            duration: 1500,
            easing: 'ease-in-out',
            once: true,  
            mirror: true,  // 🚀 위에서 아래, 아래에서 위로 이동할 때도 실행
        });

        // 🚀 AOS를 주기적으로 업데이트하여 새로운 요소를 감지
        const interval = setInterval(() => {
            AOS.refresh();
        }, 1000); // 1초마다 새로고침

        return () => clearInterval(interval); // 메모리 누수를 방지하기 위해 정리
    }, []);

    return (
        <S.Section_wide>
            <div className="MainPage">
                <div className='wrap-main'>
                {/* <section className='sec-main1'>
                    <article className='art-main1'>
                        <p className="heading-1" data-aos="fade-down" data-aos-duration="1000">
                            | 아이공 |
                        </p>

                        <p className="heading-1 mint" data-aos="zoom-in" data-aos-delay="500" data-aos-duration="1200">
                            우리 <span className="i-custom">I</span> 는 주도적으로 <span className="i-custom">I</span> 한다
                        </p>

                        <p className="heading-3" data-aos="fade-up" data-aos-delay="800" data-aos-duration="1000">
                            초중고 <strong>유형기반 학업역량</strong> 종합 진단분석 코칭프로그램ㅣ<strong>아이공</strong>
                        </p>
                    </article>
                </section> */}


                    {/* 페이지별 컴포넌트 */}
                    <MainPageSub01 />
                    <MainPageSub02 />
                    <MainPageSub03 />
                    <MainPageSub04_0 />
                    <MainPageSub05_0 />
                    <MainPageSub06_1 />
                    <MainPageSub07_1 />

                    <section className='bg_none'>
                        <Footer />
                    </section>
                </div>
            </div>
        </S.Section_wide>
    );
};

export default MainPage;
